import { createFileRoute } from '@tanstack/react-router';
import { FormsCatalog } from '@generated/components/catalog/FormsCatalog';

export const Route = createFileRoute('/_app/')({
  component: CatalogPage,
});

function CatalogPage() {
  return <FormsCatalog />;
}
